/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    // Pass through `params` so the term is URL encoded, otherwise characters
    // like &, # or + silently truncate or corrupt the search.
    return axios.get(
      this.url,
      searchKey ? { params: { search: searchKey } } : {}
    );
  }
}

export default new CannedResponse();
